import * as types from './action-types';

export function setThickness(generation, thickness) {
  return {
    type: types.SET_THICKNESS,
    payload: thickness,
    generation: generation,
  }
}

export function setFontSize(generation, size) {
  return {
    type: types.SET_FONT_SIZE,
    payload: size,
    generation: generation,
  }
}

export function setCellType(generation, type) {
  return {
    type: types.SET_CELL_TYPE,
    payload: type,
    generation: generation,
  }
}

export function setOffset(generation, offset) {
  return {
    type: types.SET_OFFSET,
    payload: offset,
    generation: generation,
  }
}

export function setStrokeVisible(generation, visible) {
  return {
    type: types.SET_STROKE_VISIBLE,
    payload: visible,
    generation: generation,
  }
}

export function batchUpdateGenerations(generations) {
  return {
    type: types.BATCH_UPDATE_GENERATIONS,
    payload: generations,
  }
}



// WEBPACK FOOTER //
// ./src/core/generations/actions.js